var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlacementCalls = function SvgPlacementCalls(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.22707 17.2065L2.85007 18.831C3.69394 19.6746 4.83833 20.1485 6.03157 20.1485C7.22481 20.1485 8.36919 19.6746 9.21307 18.831L11.5996 16.4445C11.8087 16.2355 11.9745 15.9874 12.0877 15.7143C12.2008 15.4413 12.2591 15.1486 12.2591 14.853C12.2591 14.5574 12.2008 14.2647 12.0877 13.9916C11.9745 13.7185 11.8087 13.4704 11.5996 13.2615L6.96007 8.62048C6.73287 8.39129 6.45904 8.21366 6.15714 8.09964C5.85525 7.98562 5.53236 7.93787 5.21038 7.95964C4.8884 7.98141 4.57488 8.07218 4.29108 8.2258C4.00728 8.37942 3.75984 8.5923 3.56557 8.84998C-1.29593 15.45 1.65007 22.401 7.62307 28.377C13.5961 34.353 20.5546 37.296 27.1576 32.4345C27.4147 32.2396 27.627 31.9918 27.7799 31.7077C27.9329 31.4236 28.0229 31.1099 28.044 30.7879C28.065 30.466 28.0166 30.1433 27.902 29.8417C27.7873 29.5401 27.6092 29.2667 27.3796 29.04L22.7386 24.399C22.5296 24.1899 22.2815 24.024 22.0084 23.9109C21.7354 23.7977 21.4427 23.7395 21.1471 23.7395C20.8515 23.7395 20.5588 23.7977 20.2857 23.9109C20.0126 24.024 19.7645 24.1899 19.5556 24.399L17.1706 26.7855C16.7526 27.2034 16.4211 27.6995 16.1949 28.2455C15.9687 28.7915 15.8523 29.3767 15.8523 29.9677C15.8523 30.5587 15.9687 31.144 16.1949 31.69C16.4211 32.236 16.7526 32.7321 17.1706 33.15L18.8101 34.791",
    stroke: "#0258FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 12.375C18.6652 12.375 20.3821 13.0862 21.648 14.352C22.9138 15.6179 23.625 17.3348 23.625 19.125",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 6.75C20.1571 6.75 23.3047 8.05379 25.6254 10.3746C27.9462 12.6953 29.25 15.8429 29.25 19.125",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 1.125C21.6489 1.125 26.2273 3.02142 29.6029 6.39708C32.9786 9.77273 34.875 14.3511 34.875 19.125",
    stroke: "#80ABFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlacementCalls, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/placement-calls.10f33e60.svg";
export { ForwardRef as ReactComponent };